module.exports = __webpack_public_path__ + "static/img/border-2.f4917ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/border-2.png
// module id = 9CKr
// module chunks = 0